{
	"description": "Upplýsingar",
	"descriptionPlaceholder": "Sláðu inn upplýsingar um innihald sendingarinnar",
	"sendAFile": "Veldu skjal/skjöl til að senda",
	"validReceipt": "Til þess að reikningur sé fullnægjandi þarf að koma fram vörulýsing, heildarverð og flutningskostnaður.",
	"nextStep": "Næsta skref",
	"prevStep": "< Til baka",
	"prevStepMobile": "< Til baka",
	"submit": "Senda beiðni",
	"confirm": "Staðfesta",
	"close": "Loka",
	"contentDescription": "Innihaldslýsing",
	"trackingNumbers": {
		"enter": "Sláðu inn eitt númer í einu",
		"addButton": "Bæta við",
		"errors": {
			"trackingnumber-min": "Verður að bæta við að minnsta kosti einu sendingarnúmeri",
			"validation": "Sendingarnúmer á vitlausu sniði"
		}
	},
	"recipient": {
		"noIcelandicSocialId": "Ég er ekki með íslenska kennitölu",
		"name": "Nafn",
		"namePlaceholder": "Nafn viðtakanda",
		"socialId": "Kennitala",
		"socialIdPlaceholder": "Kennitala viðtakanda",
		"email": "Netfang",
		"emailPlaceholder": "Netfang viðtakanda",
		"phone": "Sími",
		"phonePlaceholder": "Símanúmer viðtakanda",
		"errors": {
			"required": "Skylda að fylla út",
			"name-invalid": "Nafn ekki á réttu formi",
			"phone-invalid": "Símanúmerið er ekki á réttu formi",
			"phone-max": "Símanúmer má ekki vera lengra en sjö stafir",
			"phone-min": "Símanúmerið verður að vera minnst sjö stafir",
			"email-invalid": "Netfang er ekki á réttu formi",
			"ssn-min": "Kennitala verður að vera minnst 10 stafir",
			"ssn-valid": "Kennitala er ekki rétt - Aðeins tölustafir eru leyfðir, ekkert bil eða bandstrik"
		}
	},
	"shipment": {
		"hasInvoice": "Ég er með reikning",
		"openUp": "Vantar reikning. Ég vil að Pósturinn opni sendinguna og leiti að reikningi (verð 990 kr.)",
		"alreadyCleared": "Sendingin hefur þegar verið tollafgreidd með annarri sendingu",
		"gift": "Sendingin er gjöf",
		"other": "Annað",
		"errors": {
			"required": "Skylda að fylla út",
			"file-min": "Verður að bæta við skjali"
		}
	},
	"openUp": {
		"option1": "Ég vil að sending sé opnuð en ég vil vera upplýst(ur) um innihald/reikning áður en sending er tollafgreidd. (verð 990 kr)",
		"option2": "Ég vil að sending sé opnuð (verð 990 kr.) og tollafgreidd í beinu framhaldi skv. ",
		"termsLink": "https://posturinn.is/media/5caf3fjo/tollur_skilmalar.pdf",
		"terms": "skilmálum Póstsins"
	},
	"alreadyCleared": {
		"shipmentClearedText": "Sláðu inn sendingarnúmerið á þeirri sendingu sem þegar hefur verið tollafgreidd. Sendu okkur frekari upplýsingar um sendinguna og heildarreikninginn sem fylgdi með pöntuninni.",
		"shipmentClearedTrackingNumber": "Sendingarnúmer á þegar tollafgreiddri sendingu*",
		"shipmentClearedTrackingNumberPlaceholder": "Sláðu inn sendingarnúmer",
		"errors": {
			"required": "Skylda að fylla út",
			"invalid-cleared-tracking-number": "Sendingarnúmer á vitlausu sniði",
			"file-min": "Verður að bæta við skjali"
		}
	},
	"gift": {
		"explanation": "Þú greiðir ekki gjöld ef verðmæti gjafar er undir 13.500 kr. Ef gjöfin er dýrari reiknast innflutningsgjöld af þeirri upphæð sem umfram er.",
		"selectText": "Tegund gjafar*",
		"selectPlaceholder": "Veldu tegund",
		"furtherInfo": "Hér eru nánari upplýsingar frá Skattinum ",
		"furtherInfoLinkText": "um gjafir",
		"furtherInfoUrl": "https://www.skatturinn.is/einstaklingar/tollamal/sendingar-og-pakkar-til-landsins/gjafir/",
		"giftType": {
			"birthday": "Afmælisgjöf",
			"graduation": "Útskriftargjöf",
			"confirmationOrBaptise": "Fermingar- eða skírnargjöf",
			"wedding": "Brúðkaupsgjöf",
			"christmas": "Jólagjöf",
			"other": "Önnur gjöf"
		}
	},
	"delivery": {
		"explanation": "Ef þú sendir beiðnina inn fyrir kl. 11:30 getur þú óskað eftir flýtiþjónustu og fengið sendinguna samdægurs á pósthús eða í heimsendingu á höfuðborgarsvæðinu. Annars fer hún hefðbundna afhendingarleið. Greitt er fyrir flýtiþjónustu við afhendingu."
	},
	"terms": {
		"explanation": "Til þess að ganga frá beiðni um tollafgreiðslu þarftu að samþykkja skilmála um skýrslugerð. ",
		"agreeText": "Ég samþykki ",
		"termsLinkText": "skilmála um skýrslugerð",
		"termsLinkUrl": "https://posturinn.is/media/5caf3fjo/tollur_skilmalar.pdf"
	},
	"received": {
		"success": "Beiðni móttekin",
		"successText": "Takk fyrir, við munum hafa samband ef frekari upplýsinga er óskað. Þú færð tilkynningu þegar sendingin þín er tilbúin til afhendingar."
	},
	"formStepTitles": {
		"trackingNumbers": "1. Sláðu inn sendingarnúmer",
		"recipient": "2. Viðtakandi",
		"shipment": "3. Upplýsingar um sendinguna",
		"type": {
			"hasInvoice": "4. Sendu okkur reikninginn",
			"openUp": "4. Opnun sendingar",
			"alreadyCleared": "4. Sending hefur þegar verið tollafgreidd",
			"gift": "4. Hvers konar gjöf er þetta?",
			"other": "4. Aðrar upplýsingar"
		},
		"delivery": "5. Má bjóða þér flýtiþjónustu á höfuðborgarsvæðinu?",
		"terms": "Skilmálar"
	},
	"inactiveTitles": {
		"trackingNumbers": "1. Sendingarnúmer",
		"recipient": "2. Viðtakandi",
		"shipment": "3. Sendingin",
		"type": {
			"hasInvoice": "4. Sendu okkur reikninginn",
			"openUp": "4. Opnun sendingar",
			"alreadyCleared": "4. Sending hefur þegar verið tollafgreidd",
			"gift": "4. Gjöf",
			"other": "4. Upplýsingar"
		},
		"delivery": "5. Afhending",
		"terms": "Skilmálar"
	}
}